import { render } from "./currency-disclaimer.vue?vue&type=template&id=738b751c"
import script from "./currency-disclaimer.vue?vue&type=script&lang=js"
export * from "./currency-disclaimer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__